import * as React from 'react';
import { Route, Routes } from 'react-router-dom';

import { IRouteConfigComponent } from '@interfaces';

const renderRoute = (routeConfig: IRouteConfigComponent, routes: IRouteConfigComponent[]) => {
	const {
		component: Comp,
		routes: childrenRoutes,
		...route
	} = routeConfig;

	const renderedChildrenRoutes = Array.isArray(childrenRoutes) && childrenRoutes.length > 0
		? childrenRoutes.map((childrenRoute) => {
			const regex = /\*$/;
			const isWildCard = regex.test(route.path);

			return renderRoute(
				{
					...childrenRoute,
					path: isWildCard
						? childrenRoute.path.replace(
							route.path.replace(regex, ''),
							'',
						)
						: childrenRoute.path,
				},
				routes,
			);
		})
		: null;

	return (
		<Route
			key={route.path}
			{...route}
			element={
				<Comp
					key={route.path}
				/>
			}
		>
			{renderedChildrenRoutes}
		</Route>
	);
};

// eslint-disable-next-line react/display-name
export const RouterSwitch = (routes: IRouteConfigComponent[]) => () => {
	return (
		<Routes>
			{routes.map((item) => renderRoute(item, routes))}
		</Routes>
	);
};
